module.exports = __webpack_public_path__ + "static/media/plus.fd7488ca.svg";